import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './LanguageSelector.module.css';
import { SPA_ROUTES } from '@/lib/paths';
import { Link } from 'react-router-dom';

function useLanguageLabel() {
  const { i18n } = useTranslation();
  const code = (i18n.resolvedLanguage || i18n.language || 'en').replace('_', '-');
  return useMemo(() => {
    try {
      if ('DisplayNames' in Intl) {
        const base = code.split('-')[0] || code;
        const dn = new Intl.DisplayNames([code], { type: 'language' });
        const name = dn.of(base) || dn.of(code) || code;
        return name.charAt(0).toUpperCase() + name.slice(1);
      }
    } catch {
      // Ignore errors when Intl.DisplayNames is not supported or fails
    }
    return code;
  }, [code]);
}

export default function LanguageSelector({ className }: { className?: string }) {
  const langLabel = useLanguageLabel();

  const href = useMemo(() => {
    const current = window.location.pathname + window.location.search;

    const q = `?languageReturnUrl=${encodeURIComponent(current)}`;
    return `${SPA_ROUTES.LANGUAGE}${q}`;
  }, []);

  return (
    <div className={`${styles.langRow} ${className ?? ''}`}>
      <Link to={href} className={styles.langLink} title="Change language">
        {langLabel}
      </Link>
    </div>
  );
}
